export default "__VITE_ASSET__d4b218f9__"